import React from "react"
import { Helmet } from "react-helmet"
import { navigate } from "gatsby"

import { SpotifyApiContext } from 'react-spotify-api'

import Calendar from "../components/calendar"
import NoAccount from "../components/NoAccount"
import SignOut from "../components/signout"
import useUser from "../hooks/useUser"
import GraphPicker from "../components/graphPicker"
import MoodEntityAnalysis from "../components/moodentityanalysis"

import styles from "../styles/homepage.module.css"

const Render = () => (
  <>
    <Helmet>
      <title>Char.ly</title>
      <link rel="icon" href="/static/icon.png" />
    </Helmet>
    <head>
      <link href="/bootstrap/css/bootstrap.min.css" rel="stylesheet"></link>
      <script src="/scripts/jquery.min.js"></script>
      <script src="/bootstrap/js/bootstrap.min.js"></script>
    </head>
    <div className={styles.body}>
      <div class={styles.row}>
        <div class={styles.calendar}>
          <div class={styles.calendar_box}>
            <Calendar/>
          </div>
        </div>
        <div className = {styles.topRight}>
        <div class={styles.navbar}>
        <h1>Welcome</h1>
        <SignOut/>
      </div>
        <div className={styles.create_note}>
          
          <h1>How are you feeling?</h1>
          <button onClick={()=>navigate("/journal")}>+</button>
          <h2>Create Note</h2>
        </div>
        </div>
      </div>
      <div class={styles.mood_tracking}>
        <div className={styles.left}>
          <p className={styles.analysisTitle}>mood tracker</p>
          
          <p className={styles.analysis}> 
         <MoodEntityAnalysis/>
          </p>
          
        </div>
        <div className={styles.right}>
          <div className={styles.chartContainer}>
          <GraphPicker index={0}/>
          </div>
        </div>
      </div>
    </div>
  </>)

export default () => {

  const user = useUser()
  console.log(user)

  return (
    (user) ? <Render /> : <NoAccount />
  )

}

//const db = firebase.firestore()
//             console.log(user.uid)
            
//             var user_calendar_colors = {};
//             db.collection('users').doc(user.uid).collection('journals').get().then(querySnapshot => {
//                 querySnapshot.forEach(doc => {
//                     const journal = doc.data();

//                     console.log("DATA", doc.data())

//                     const entry_color = getColor(journal);
//                     const date_created = journal.created.toDate()


//                     console.log("JOURNAL SENTIMENT SCORE ", journal.sentimentScore)
//                     console.log(date_created);
//                     console.log(entry_color)
                    
//                     user_calendar_colors[date_created] = entry_color;
                    

//                     {/*
//                     changeCalendarDate(toDateTime(journal.created.seconds))
//                     console.log("DATE", toDateTime(journal.created.seconds))
                    
//                     calendarColors.calendarDate = getColor()
//                 */}